import React from 'react';

import {
  CardCopyType,
  CardTypes,
  cardCopy,
} from 'src/modules/designStudio/components/Toolbar/toolBarConstants';
import { useTranslate } from 'src/shared/hooks';

import { Menu } from '../../constants';
import { ExtendedMacheteViewer } from '../../helpers/machete';

import { DesignCard } from './DesignCard';
import { InactiveFeatureCard } from './InactiveFeatureCard';
import { ResetCard } from './ResetCard';
import { ShareCard } from './ShareCard';

interface PropTypes {
  menu: Menu | null;
  jobId: number;
  closeMenu: () => void;
  viewer: ExtendedMacheteViewer | null;
}

const DesignMenu = ({ menu, closeMenu, jobId, viewer }: PropTypes) => {
  let itemCopy: CardCopyType = cardCopy.DEFAULT;
  const t = useTranslate('designStudio');

  if (menu) {
    itemCopy = cardCopy?.[menu];
  }

  const body = itemCopy.body ? t(itemCopy.body || '') : '';
  const title = itemCopy.title ? t(itemCopy.title) : '';

  switch (itemCopy.cardType) {
    case CardTypes.INACTIVE_FEATURE:
      return (
        <InactiveFeatureCard
          bodyText={body}
          closeMenu={closeMenu}
          feature={itemCopy.feature}
          headerText={title}
        />
      );
    case CardTypes.RESET:
      return (
        <ResetCard bodyText={body} closeMenu={closeMenu} headerText={title} />
      );
    case CardTypes.SHARE:
      return (
        <ShareCard
          closeMenu={closeMenu}
          headerText={title}
          jobId={jobId}
          viewer={viewer}
        />
      );
    default:
      return (
        <DesignCard closeMenu={closeMenu} headerText={title} menu={menu} />
      );
  }
};

export { DesignMenu };
